import {
  AvailableSchedulePeriod,
  ITimeSlotTimestamp,
} from '../models/schedule-calendar.models';

export const baseTimeSlotMock: ITimeSlotTimestamp = {
  start: '2026-10-01T09:00:00.000Z',
  end: '2026-10-01T10:00:00.000Z',
};

export const baseAvailableSchedulePeriodMock: AvailableSchedulePeriod = {
  ...baseTimeSlotMock,
  isPreferred: false,
};
